import { clsx } from "clsx"
import { useEffect, useRef } from "react"
import "./style.sass"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean
  children: React.ReactNode
}
export const Collapse = ({ open, children, ...rest }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.maxHeight = open ? contentRef.current.scrollHeight + "px" : "0px"
    }
  }, [open])

  return (
    <div {...rest} className={clsx("collapse-content", rest.className)} ref={contentRef}>
      {children}
    </div>
  )
}
